const overrides = {
    field: {
        ownsHomeIndicator: {
            partner: {
                MSA: {
                    states: ['IL', 'IN', 'KY', 'OH', 'NJ', 'PA', 'UT']
                }
            }
        }
    }
};

export default overrides;
